var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m66.295 249.494c2.033-2.033 4.828-3.218 7.792-3.218h268.828c4.912 0 7.369 5.929 3.896 9.401l-53.105 53.105c-2.033 2.033-4.828 3.218-7.792 3.218h-268.828c-4.912 0-7.369-5.929-3.896-9.401z",
    fill: "#fff",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m66.294 51.218c2.118-2.032 4.913-3.218 7.793-3.218h268.828c4.912 0 7.369 5.929 3.896 9.401l-53.105 53.105c-2.033 2.033-4.828 3.218-7.792 3.218h-268.828c-4.912 0-7.369-5.929-3.896-9.401z",
    fill: "#fff",
    "data-original": "#fff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m293.706 149.721c-2.033-2.033-4.828-3.218-7.792-3.218h-268.828c-4.912 0-7.369 5.929-3.896 9.401l53.105 53.105c2.033 2.033 4.828 3.218 7.792 3.218h268.828c4.912 0 7.369-5.929 3.896-9.401z",
    fill: "#fff",
    "data-original": "#fff",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.84d694076ca515a412d56300c54fcc68.svg";
export { ForwardRef as ReactComponent };